import { FC } from 'react';
import { Img } from 'react-suspense-img';

interface Props {
  url: string;
}

export const ImagePreloader: FC<Props> = ({ url }) => {
  // Render a tiny invisible version of any images we'll be likely to need.
  // These are then kept in the cache for when they're needed.
  return <>{url && <Img src={url} className="opacity-0 absolute top-0 left-0 h-1 w-1" />}</>;
};
